import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1545.048 -4146.566)">
      <path
        d="M98.7,43.316a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1628 4104)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M113.461,55.714A14.986,14.986,0,0,0,98.7,43.317v15l12.98,7.495a14.914,14.914,0,0,0,2.019-7.495,15.077,15.077,0,0,0-.24-2.6"
        transform="translate(-1628 4104)"
        fill={color}
      />
    </g>
  </svg>
);
